<template>
    <section v-if="type === 'wide'" class="wide_section" data-aos="fade-up">
        <div class="inner">
            <slot></slot>
        </div>
    </section>
    <section v-else data-aos="fade-up">
        <slot></slot>
    </section>
</template>
<script>
export default {
    props: {
        type: {},
    },
};
</script>
<style lang="scss" scoped>
section {
    width: 100%;
    max-width: 1540px;
    margin: 0 auto;
    padding: 120px 0;

    &.wide_section {
        max-width: 100%;
        background: var(--gray2);

        .inner {
            width: 100%;
            max-width: 1540px;
            margin: 0 auto;
        }
    }
}

@media screen and (max-width: 1600px) {
    section {
        max-width: 90%;

        &.wide_section {
            .inner {
                max-width: 90%;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    section {
        width: 100%;
        max-width: 100%;
        padding: 10vmin 5%;
        margin: 0;
    }
}
</style>
